export default function headerScroll() {
    return {
        lastScrollY: window.scrollY,
        ticking: false,
        threshold: 120,
        
        init() {
            // Cache initial state to prevent unnecessary DOM updates
            this.handleScroll();
            window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
        },
        
        onScroll() {
            if (!this.ticking) {
                this.ticking = true;
                requestAnimationFrame(() => {
                    this.handleScroll();
                    this.ticking = false;
                });
            }
        },
        
        handleScroll() {
            const { scrollY } = window;
            const scrollingUp = scrollY < this.lastScrollY;
            const pastThreshold = scrollY >= this.threshold;
            
            // Only update classes if scroll direction matters (past threshold)
            if (pastThreshold) {
                const { classList } = document.body;
                
                if (scrollingUp) {
                    if (!classList.contains('scrolling-up')) {
                        classList.add('scrolling-up');
                        classList.remove('scrolling-down');
                    }
                } else {
                    if (!classList.contains('scrolling-down')) {
                        classList.add('scrolling-down');
                        classList.remove('scrolling-up');
                    }
                }
            } else {
                // Remove both classes when above threshold
                const { classList } = document.body;
                if (classList.contains('scrolling-up') || classList.contains('scrolling-down')) {
                    classList.remove('scrolling-up', 'scrolling-down');
                }
            }
            
            this.lastScrollY = scrollY;
        },
        
        // Cleanup method for component destruction
        destroy() {
            window.removeEventListener('scroll', this.onScroll.bind(this));
        }
    };
}